import type { BossConfig } from '../../entities/BossConfig';

export const ELK_CONFIG: BossConfig = {
  id: 'elk',
  displayName: 'Лось',
  bossType: 'charging',

  maxHp: 100,
  speed: 0,
  movementBehavior: 'charging_boss',

  chargingParams: {
    idleMs: 1800,
    windupMs: 600,
    chargeSpeed: 450,
    recoveryMs: 1200,
    contactDamage: 0,
  },

  invulnerableInPhases: ['charge'],
  contactBehavior: 'instakill',
  instakillDragMs: 400,

  // Бег только на charge — в покое (idle/windup/recovery) стоп-кадр.
  // Иначе windup при 0.5× выглядел бы как "бег на месте".
  animateOnlyOnCharge: true,

  size: 110,
  color: 0x5c4a2f,

  // Визуальный язык: тёплые цвета (idle/recovery) = бей, холодный (charge) = жди.
  phaseTints: {
    idle: 0x6b5a3a,
    windup: 0x8a7340,
    charge: 0x3a4a5c,
    recovery: 0x6b5a3a,
  },

  scoreReward: 750,
};
